import React from 'react';
import {
    BudgetProposalT,
    CellRendererParams,
} from 'routes/BudgetModule/config/types';
import { SPLIT_BY } from 'routes/BudgetModule/config/constants';
import { budgetPercentageFormatter } from 'ui/AgGridReact/formatters';
import ChipCellRenderer, {
    ChipCellRendererParams,
} from 'ui/AgGridReact/CellRenderers/ChipCellRenderer';

type PercentRealizedCellRendererParams = CellRendererParams<unknown, string> & {
    budgetProposal: BudgetProposalT;
} & Omit<ChipCellRendererParams, 'node' | 'valueFormatted'>;

export default function PercentRealizedCellRenderer({
    node,
    valueFormatted,
    budgetProposal,
    ...rest
}: PercentRealizedCellRendererParams): React.ReactElement | null | string {
    // Well, AgGrid doesn't provide a type for aggData
    if (node.aggData) {
        // We do the aggregation here instead of a custom aggFunc
        // because there are multiple issues to solve when doing so:
        // - inscription edition triggers a blink
        // - inscription creation does not work
        const { exercice } = budgetProposal;
        const totalAmountRealized =
            node.aggData[`budgetLine.amountRealized${SPLIT_BY}${exercice - 1}`];
        const totalFullAmount =
            node.aggData[`budgetLine.fullAmount${SPLIT_BY}${exercice - 1}`];

        if (!totalFullAmount) return null;

        return budgetPercentageFormatter({
            value: totalAmountRealized / totalFullAmount,
        });
    }

    return valueFormatted ? (
        <ChipCellRenderer
            {...rest}
            node={node}
            valueFormatted={valueFormatted}
        />
    ) : null;
}
